

// When page loads fadeInUp first, second and third lines with a slight delay in between each line

$( document ).ready(function() {
	
	$('.first').show().addClass('animate-fadeUp');
	
	setTimeout(function () {
		$('.second').show().addClass('animate-fadeUp');}, 500
	);
	
	setTimeout(function () {
		$('.third').show().addClass('animate-fadeUp');}, 1000
	);
	
});